import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "../lib/api";

const SEEN = "pb-done-seen";

export const DoneAlerts = () => {
  const nav = useNavigate();
  const first = useRef(true);
  useEffect(() => {
    const tick = async () => {
      try {
        const { data } = await http.get("/ops/events");
        const seen = new Set(JSON.parse(localStorage.getItem(SEEN) || "[]"));
        const fresh = Date.now() - 90 * 1000;
        data.events.filter((e) => !seen.has(e.key)).forEach((e) => {
          seen.add(e.key);
          if (first.current && new Date(e.at) < fresh) return;
          (e.ok ? toast.success : toast.warning)(e.title, {
            description: e.text, duration: 12000,
            action: e.kit_id ? { label: "Open kit", onClick: () => nav(`/kits/${e.kit_id}`) } : undefined,
          });
        });
        first.current = false;
        localStorage.setItem(SEEN, JSON.stringify([...seen].slice(-200)));
      } catch { /* offline or signed out */ }
    };
    tick();
    const t = setInterval(tick, 15000);
    return () => clearInterval(t);
  }, [nav]);
  return null;
};
